import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_LISTING_NOTES,
  DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER,
} from 'common/dataTableConstants';

import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrNotesList, {
  SR_LISTING_NOTES_VISIBLE_TO_PARTNER,
  SR_NOTES_LIST_THEME_GREYCLIFF,
} from 'client/components/SrNotesList';
import SrCard from './SrCard/SrCard';
import SrText from './SrText';

const SrPartnerSunroomNotes = ({
  listingId,
  dispatch,
  currentUser,
}) => (
  <SrDataTableConnected
    itemsPropName='notes'
    rootViewId={DATA_TABLE_VIEW_ID_LISTING_NOTES_VISIBLE_TO_PARTNER}
    dataSource={DATA_TABLE_SOURCE_LISTING_NOTES}
    initialViewSettings={{
      sort: {
        createdDate: 'desc',
      },
      filter: {
        listingId,
        visibleToPartner: true,
      },
    }}
  >
    {({ notes, reloadItems, dataTableApiState, onInfiniteScrollWrapperRef }) => (
      <>
        <SrCard overflowY='auto' maxHeight='200px' ref={onInfiniteScrollWrapperRef}>
          { notes.length > 0
            ? (
              <SrNotesList
                type={SR_LISTING_NOTES_VISIBLE_TO_PARTNER}
                theme={SR_NOTES_LIST_THEME_GREYCLIFF}
                notes={notes}
                dispatch={dispatch}
                reloadDataTable={(noteId) => {
                  reloadItems({
                    count: 1,
                    filter: {
                      'listingNotes.id': noteId,
                      'listingNotes.visibleToPartner': true,
                    },
                  });
                }}
                currentUser={currentUser}
              />
            )
            : (
              <SrText>
                Sunroom may share relevant updates and notes about this listing
                and leasing process here.
              </SrText>
            )
          }
        </SrCard>
        {dataTableApiState.inProgress && (
          <SrFlex justify='center'>
            <div className='loading-gif' />
          </SrFlex>
        )}
      </>
    )}
  </SrDataTableConnected>
);

SrPartnerSunroomNotes.propTypes = {
  listingId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrPartnerSunroomNotes.displayName = 'SrPartnerSunroomNotes';

export default SrPartnerSunroomNotes;
